module.exports = __webpack_public_path__ + "static/media/2.89aa1f27.png";